import { prop, inject, ComponentEventBus } from "fw";

export type LegendItem = { label: string; color: string };

@inject
export class ChartLegend {
    @prop([]) items!: LegendItem[];
    @prop(false) interactive!: boolean;

    constructor(private ceb: ComponentEventBus) {}

    isMissing(s: LegendItem) {
        return s.label == "__missing__" || s.label == "NaN";
    }

    public click(key: string) {
        this.ceb.dispatch("legend-click", key);
    }
}
